import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-modal-request-tigo-sale-order',
  templateUrl: './modal-request-tigo-sale-order.page.html',
  styleUrls: ['./modal-request-tigo-sale-order.page.scss'],
})
export class ModalRequestTigoSaleOrderPage implements OnInit {
  questions = [ {label: 'Pedido Instalación',format: 'input',type: 'text',formControl: new FormControl('', [Validators.required])}]

  constructor(private modalController: ModalController, private analyticsService: AnalyticsService) {
    this.analyticsService.AnalyticsServiceModalView('request-tigo-sale-order');
   }

  ngOnInit() {
  }

  saveResult() {
    this.modalController.dismiss(this.questions[0].formControl.value);
  }

  closeModal() {
    this.modalController.dismiss();
  }

}
